import React, { useEffect, useState } from "react";
import { Button, Table, Tag, Alert } from "antd";
import adminApi from "../../services/adminApi";
import PageHeader from "../../components/PageHeader";

const UsersPage: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setLoadError(null);
    try {
      const res = await adminApi.getUsers();
      setUsers(res.data.data);
    } catch (e: any) {
      setLoadError(e.response?.data?.message || "Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <PageHeader title="Users" />
      <div className="page-panel">
        <Alert
          type="info"
          showIcon
          message="Accounts are provisioned by the platform operator. This list is read-only."
          style={{ marginBottom: 10 }}
        />
        {loadError && (
          <Alert
            type="error"
            showIcon
            message={loadError}
            action={
              <Button size="small" onClick={load}>
                Retry
              </Button>
            }
            style={{ marginBottom: 10 }}
          />
        )}
        <Table
          className="dense-table"
          size="small"
          rowKey="_id"
          loading={loading}
          dataSource={users}
          columns={[
            { title: "Name", dataIndex: "name" },
            { title: "Email", dataIndex: "email" },
            {
              title: "Role",
              dataIndex: "role",
              render: (role: string) => <Tag>{role}</Tag>,
            },
            {
              title: "Status",
              dataIndex: "isActive",
              render: (active: boolean) => (
                <Tag color={active !== false ? "green" : "default"}>
                  {active !== false ? "Active" : "Inactive"}
                </Tag>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default UsersPage;
